<template>
  <router-link
    :to="disabled ? '#' : route"
    :class="[
      'bg-white rounded-2xl shadow-lg overflow-hidden border card-hover group relative',
      disabled 
        ? 'border-gray-100 opacity-60 cursor-not-allowed' 
        : 'border-gray-100 cursor-pointer'
    ]"
  >
    <div class="p-6 flex flex-col h-full">
      <div class="flex items-center mb-4">
        <div 
          class="w-12 h-12 bg-gradient-to-br rounded-xl flex items-center justify-center flex-shrink-0 text-white"
          :class="color || 'from-gray-400 to-gray-500'"
        >
          <component :is="icon" class="w-6 h-6" />
        </div>
        <div class="ml-4 flex-1">
          <h3 class="text-xl font-bold text-gray-900">{{ title }}</h3>
          <p class="text-sm text-gray-500">{{ description }}</p>
        </div>
      </div>

      <div v-if="disabled" class="flex-1 flex items-center justify-center">
        <div class="text-center">
          <LockClosedIcon class="w-8 h-8 mx-auto mb-2 text-gray-300 opacity-60" />
          <span class="inline-block px-3 py-1 bg-gray-100 text-gray-400 text-xs rounded-full">
            Coming Soon
          </span>
        </div>
      </div>

      <div v-else class="mt-auto">
        <div 
          class="w-full py-2.5 px-4 rounded-xl text-center text-sm font-medium transition-all flex items-center justify-center"
          :class="[
            'bg-gradient-to-r from-primary-500 to-indigo-600 text-white group-hover:shadow-lg'
          ]"
        >
          <span>Get Started</span>
          <svg class="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
          </svg>
        </div>
      </div>
    </div>

    <div 
      v-if="!disabled"
      class="absolute inset-0 bg-gradient-to-r from-primary-500/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
    ></div>
  </router-link>
</template>

<script setup>
import { LockClosedIcon } from '@heroicons/vue/24/outline'

defineProps({
  title: {
    type: String,
    required: true
  },
  icon: {
    type: Object,
    required: true
  },
  description: {
    type: String,
    required: true
  },
  route: {
    type: String,
    default: '#'
  },
  color: {
    type: String,
    default: 'from-primary-500 to-indigo-600'
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
</script>
